'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import H2 from 'UIComponents/elements/headings/H2';
import UICardSection from 'UIComponents/card/UICardSection';
import Big from 'UIComponents/elements/Big';
import ProfileCardWrapper from './ProfileCardWrapper';

const AboutCard = ({
  profileListing
}) => {
  const {
    name,
    description
  } = profileListing;
  return /*#__PURE__*/_jsx(ProfileCardWrapper, {
    id: "about",
    children: /*#__PURE__*/_jsxs(UICardSection, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.profile.about",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(Big, {
        style: {
          lineHeight: '28px',
          whiteSpace: 'pre-wrap'
        },
        children: description
      })]
    })
  });
};

AboutCard.propTypes = {
  profileListing: PropTypes.instanceOf(ProfileListing)
};
export default AboutCard;